import { render } from "./FixedBlockControl.vue?vue&type=template&id=668e5ffc"
import script from "./FixedBlockControl.vue?vue&type=script&lang=js"
export * from "./FixedBlockControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__